var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.3991,
    height: 31,
    rx: 15.5,
    fill: "#F6867A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5987 10.9913C19.4186 10.8913 19.2206 10.8276 19.016 10.8041C18.8113 10.7806 18.604 10.7976 18.4059 10.8542C18.2078 10.9107 18.0229 11.0058 17.8615 11.1339C17.7002 11.262 17.5656 11.4206 17.4656 11.6007L14.5538 16.8409L12.8873 15.1744C12.7426 15.0246 12.5695 14.9051 12.3782 14.8229C12.1868 14.7407 11.981 14.6974 11.7728 14.6956C11.5645 14.6938 11.358 14.7335 11.1652 14.8124C10.9724 14.8912 10.7973 15.0077 10.6501 15.155C10.5028 15.3022 10.3863 15.4773 10.3075 15.6701C10.2286 15.8629 10.1889 16.0694 10.1907 16.2777C10.1925 16.4859 10.2358 16.6917 10.318 16.8831C10.4002 17.0744 10.5197 17.2475 10.6695 17.3922L13.8064 20.5291C14.1028 20.8263 14.5028 20.9894 14.9153 20.9894L15.1325 20.9738C15.3729 20.9401 15.6023 20.8512 15.8024 20.7138C16.0026 20.5765 16.1682 20.3946 16.2861 20.1825L20.2073 13.1244C20.3074 12.9444 20.371 12.7464 20.3946 12.5418C20.4182 12.3372 20.4013 12.1299 20.3448 11.9318C20.2883 11.7338 20.1933 11.5488 20.0653 11.3874C19.9373 11.226 19.7787 11.0914 19.5987 10.9913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b239e60fa1eb4ca95385de664c65e8dc.svg";
export { ForwardRef as ReactComponent };